"use strict";

exports.__esModule = true;
exports.DataTableFields = DataTableFields;
exports.boostrapDefaultColumns = boostrapDefaultColumns;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _Fields = require("../AdvancedDataTable/Fields");
var _widget = require("../DataTableColumn/widget");
var _DataSources = require("./DataSources");
var _Fields2 = require("./Fields");
var _excluded = ["columns"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function boostrapDefaultColumns(configuration, elementEditor, definition, path) {
  if (configuration === void 0) {
    configuration = {};
  }
  // Use the definition to bootstrap a default configuration for the editor
  var _definition$createDef = definition.createDefault(),
    templatedColumns = _definition$createDef.columns,
    defaultConfig = _objectWithoutPropertiesLoose(_definition$createDef, _excluded);

  // Go through and merge in the actual definition column props to the template one to make sure nothing vital is missed
  var columns = templatedColumns.map(function (col) {
    var realColumn = definition.columns.find(function (c) {
      return c.id === col.id;
    });
    if (!realColumn) {
      console.error("A template column must have an id and exist in the main definition list of columns");
    }
    return Object.assign({}, realColumn, col);
  });
  configuration = defaultConfig;

  // bootstrap the child elements
  elementEditor.modifyElementAt(path, function (el) {
    el.props.configuration = defaultConfig;

    // Create a column for each in the defaults as a child of the element. Note: Destroys existing configured columns
    el.children = columns.map(function (column) {
      return _widget.DataTableColumnWidget.createElement(Object.assign({}, column));
    });
  });
  return configuration;
}

/**
 * Fields for DataTableElement.
 */
function DataTableFields(props) {
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var translate = translator.translate;
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var dataSource = element.props.dataSource;
  var definition = _DataSources.DataSourceDefinitions[dataSource](translate);
  var configuration = element.props.configuration;
  if (!configuration) {
    configuration = boostrapDefaultColumns(configuration, elementEditor, definition, path);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fields2.DataSourceField, {
    value: dataSource,
    setProp: function setProp(val) {
      if (val !== dataSource) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.dataSource !== val) {
            el.props.configuration = null; // this triggers bootstrap above
            el.children = [];
            el.props.dataSource = val;
          }
        });
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields2.AddColumnField, {
    dataSourceDefinition: definition,
    onAddColumn: function onAddColumn(column) {
      elementEditor.appendElementAt(path, _widget.DataTableColumnWidget.createElement(Object.assign({}, column)));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
    setProp: function setProp(value) {
      elementEditor.setProp(path, "dataRange", value);
    },
    value: element.props.dataRange || "",
    fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
    setFetchOnlyOnSelection: function setFetchOnlyOnSelection(value) {
      elementEditor.setProp(path, "fetchDataOnlyOnSelection", value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields2.PaginationField, {
    defaultPageSize: configuration.defaultPageSize,
    setDefaultPageSize: function setDefaultPageSize(val) {
      return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
        defaultPageSize: val
      }));
    }
  }));
}